export default function () {
  const track = document.getElementById("stepsSliderTrack");
  const slides = document.querySelectorAll(".steps-slider__slide");
  const dots = document.querySelectorAll(".steps-slider__dot");

  let currentIndex = 0;
  const totalSlides = slides.length;

  function updateSlider(index) {
    if (index < 0 || index >= totalSlides) return;
    currentIndex = index;

    track.style.transform = `translateX(-${currentIndex * 100}%)`;

    //Активация текущей точки
    dots.forEach((dot, i) => {
      dot.classList.toggle("is-active", i === currentIndex);
    });
  }

  //--< Обработка кликов по точкам >-----------------------

  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      updateSlider(index);
    });
  });

  //--< Обработка скролла мышкой >-------------------------

  let wheelBlock = false;
  const inner = document.querySelector(".steps-slider__inner");

  inner.addEventListener(
    "wheel",
    (e) => {
      e.preventDefault();
      if (wheelBlock) return;

      wheelBlock = true;
      const dir = e.deltaY > 0 ? 1 : -1;
      updateSlider(currentIndex + dir);

      setTimeout(() => {
        wheelBlock = false;
      }, 700);
    },
    { passive: false },
  );

  //--< Обработка свайпов на сенсорном экране >------------

  let touchStartX = 0;
  let isSwiping = false;

  inner.addEventListener(
    "touchstart",
    (e) => {
      touchStartX = e.changedTouches[0].screenX;
      isSwiping = true;
    },
    { passive: true },
  );

  inner.addEventListener(
    "touchmove",
    (e) => {
      if (!isSwiping) return;
      e.preventDefault();
    },
    { passive: false },
  );

  inner.addEventListener(
    "touchend",
    (e) => {
      if (!isSwiping) return;
      isSwiping = false;

      const touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          updateSlider(currentIndex + 1);
        } else {
          updateSlider(currentIndex - 1);
        }
      }
    },
    { passive: true },
  );

  updateSlider(0);
}
